module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modals-container"
  }, [_c('MenuItemModal'), _vm._v(" "), _c('TermItemModal'), _vm._v(" "), _c('SelectelUploadModal')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f1b661b0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modals.vue
// module id = 1001
// module chunks = 0